import GetFupOrganisationsRequestModelBase from '../_generated/modelBases/get-fup-organisations-request-model-base';

export default class GetFupOrganisationsRequestModel extends GetFupOrganisationsRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
